export enum EOpenPoseBodyNode {
  /*
   * CENTER
   */
  CENTER = 'center',

  /*
   * EARS
   */
  EAR_LEFT = 'ear_left',
  EAR_RIGHT = 'ear_right',

  /*
   * ELBOWS
   */
  ELBOW_LEFT = 'elbow_left',
  ELBOW_RIGHT = 'elbow_right',

  /*
   * EYES
   */
  EYE_LEFT = 'eye_left',
  EYE_RIGHT = 'eye_right',

  /*
   * FEET
   */
  FOOT_LEFT = 'foot_left',
  FOOT_RIGHT = 'foot_right',

  /*
   * HANDS
   */
  HAND_LEFT = 'hand_left',
  HAND_RIGHT = 'hand_right',

  /*
   * HIPS
   */
  HIP_LEFT = 'hip_left',
  HIP_RIGHT = 'hip_right',

  /*
   * KNEES
   */
  KNEE_LEFT = 'knee_left',
  KNEE_RIGHT = 'knee_right',

  /*
   * ANKLES
   */
  ANKLE_LEFT = 'ankle_left',
  ANKLE_RIGHT = 'ankle_right',

  /*
   * NECK
   */
  NECK = 'neck',

  /*
   * NOSE
   */
  NOSE = 'nose',

  /*
   * SHOULDERS
   */
  SHOULDER_LEFT = 'shoulder_left',
  SHOULDER_RIGHT = 'shoulder_right',

  /*
   * WRISTS
   */
  WRIST_LEFT = 'wrist_left',
  WRIST_RIGHT = 'wrist_right',
}
